var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNexo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3CA9E5",
    d: "m8.29 5.574l7.557 4.253v4.339L4.287 7.663L7.992 5.58a.32.32 0 0 1 .297 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2853C3",
    d: "m15.853 5.487l-3.855 2.17l3.855 2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A4199",
    d: "m15.853 5.487l3.708 2.083a.3.3 0 0 1 .148.255v8.51l-3.856-2.164z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2853C3",
    d: "m19.715 16.338l-3.713 2.086a.32.32 0 0 1-.314 0L8.13 14.171v-4.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#60BEFF",
    d: "M4.286 7.657v8.51a.3.3 0 0 0 .148.266l3.708 2.083V9.827z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CA9E5",
    d: "m8.142 18.51l3.856-2.169l-3.856-2.175z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexo);
export default __webpack_public_path__ + "static/media/nexo.b859d5a4e2882529aa705e49d64a50b0.svg";
export { ForwardRef as ReactComponent };